<div class="flex flex-col items-center justify-center gap-4">
  @if (loadingWorkspace) {
    <mat-spinner />
    @if (workspaceService.workspace$ | async; as workspaceValue) {
      <p class="mat-body-2">Loading {{ workspaceValue }}</p>
    }
  } @else {
    @if (workspaces$ | async; as workspaces) {
      @if (workspaces.length) {
        <ng-container #workspacesContainer />
      } @else {
        <p>
          This email address isn't associated with any workspaces. Please
          contact your workspace admin.
        </p>
      }
    } @else {
      <mat-spinner class="flex" />
      <p class="mat-body-2">Loading workspaces</p>
    }
  }
</div>
